// extracted by mini-css-extract-plugin
export default {"dialog":"AztecCameraScanner-pvI0k__dialog","zxing-video":"AztecCameraScanner-wb7C3__zxing-video"};